import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "hero-body"
};
var _hoisted_2 = {
  class: "container"
};

var _hoisted_3 = /*#__PURE__*/_createVNode("h1", {
  class: "title"
}, " Tiago J C Oliveira ", -1);

var _hoisted_4 = {
  class: "subtitle"
};
var _hoisted_5 = {
  id: "app",
  class: "section"
};
export function render(_ctx, _cache) {
  var _component_NavComponent = _resolveComponent("NavComponent");

  var _component_router_view = _resolveComponent("router-view");

  var _component_FooterComponent = _resolveComponent("FooterComponent");

  return _openBlock(), _createBlock(_Fragment, null, [_createVNode(_component_NavComponent), _createVNode("section", {
    class: "hero is-info",
    alt: _ctx.locale
  }, [_createVNode("div", _hoisted_1, [_createVNode("div", _hoisted_2, [_hoisted_3, _createVNode("h2", _hoisted_4, _toDisplayString(_ctx.t("message.template.hero.subtitle")), 1)])])], 8, ["alt"]), _createVNode("section", _hoisted_5, [_createVNode(_component_router_view)]), _createVNode(_component_FooterComponent)], 64
  /* STABLE_FRAGMENT */
  );
}